import { Environment } from './environment.types';

const environment: Partial<Environment> = {
  apiBaseUrl: 'https://staging-qms-api.sierralabs.io/api/',
  jiraUrl: 'http://demoqms.sierralabs.com:8080/',
  accessTokenKey: 'Authorization',
  bearerPrefix: 'bearer',
  accessDeniedPath: '/access-denied',
  expires: 365,
  secure: true,
  tinyApiKey: '28wr7ysrep8u469n6qqpzvzmn9uyye4phxcstpwrtdh6blk1',
  recaptchaSiteKey: '6LfLJtQjAAAAAF5Eymo01VfMF2qxtY7C1r8j-MxT',
  productConfig: {
    userNeed: {
      name: 'User Requirement',
      idPrefix: 'UR'
    },
    designInput: {
      name: 'Product Requirements',
      idPrefix: 'PR',
      hideRiskField: true,
      useCustomInfoFields: true
    },
    designOutput: {
      name: 'General Requirements',
      idPrefix: 'REQ',
      useCustomInfoFields: true
    },
    validation: {
      hideTestSteps: true
    },
    verification: {
      hideTestSteps: true
    },
    designSpec: {}
    // validation: { disableRelations: ['userNeeds'] },
  },
  hazardConfig: {
    idPrefix: 'HS',
    control: {
      visibleJiraFields: [
        {
          title: 'eCW Test ID',
          fieldKey: 'customfield_11000',
          type: 'text'
        }
      ]
    }
  },
  riskConfig: {
    useCustomFields: true
  },
  changeOrderConfig: {
    useCustomFields: true
  }
};

export default environment;
